import { Component, Input, OnInit } from '@angular/core';
import { PrepaidClinicSupply } from '@models/prepaid-clinic-supply';
import { PatientService } from '@services/patient.service';

@Component({
  selector: 'app-prepaid-clinic-supplies-list',
  templateUrl: './prepaid-clinic-supplies-list.component.html',
  styleUrls: ['./prepaid-clinic-supplies-list.component.less'],
})
export class PrepaidClinicSuppliesListComponent {
  private _patientId: number;
  @Input() set patientId(value: number) {
    this._patientId = value;
    this.loadPrepaidClinicSupplies();
  }
  get patientId() {
    return this._patientId;
  }
  @Input() showHeader: boolean = true;

  prepaidClinicSupplies: PrepaidClinicSupply[] = [];
  loading = false;

  constructor(private patientService: PatientService) {}

  loadPrepaidClinicSupplies() {
    if (!this.patientId) {
      return;
    }

    this.loading = true;
    this.patientService.getPrepaidClinicSupplies(this.patientId).subscribe({
      next: (supplies: PrepaidClinicSupply[]) => {
        this.prepaidClinicSupplies = supplies;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }
}
